import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";
import { menuContext } from "../../Context/menuContex";

export const ShoppingCartItem = ({ item }) => {
  const { toShoppin, setToShoppin, saveToLocalStorage } =
    useContext(menuContext);
  const [counter, setCounter] = useState(item.quantity || 1);

  useEffect(() => {
    let productIndex;
    if (item.adicionalsId) {
      productIndex = toShoppin.findIndex(
        (product) => product.adicionalsId === item.adicionalsId
      );
    } else {
      productIndex = toShoppin.findIndex((product) => product.id === item.id);
    }
    if (productIndex !== -1) {
      // Copiar el array de productos
      const updatedToShoppin = [...toShoppin];
      // Actualizar el contador del producto específico
      updatedToShoppin[productIndex].quantity = counter;
      // Actualizar el estado global con el nuevo array
      setToShoppin(updatedToShoppin);
      // Guardar en el almacenamiento local
      saveToLocalStorage(updatedToShoppin);
    }
  }, [counter]);

  return (
    <div className=" w-full border border-gray p-1 pt-0 rounded-xl drop-shadow-lg">
      <span className=" flex justify-between">
        <h2 className=" font-bold text-lg ">{item.name}</h2>
        <p className="font-semibold place-self-end text-base mr-2">
          $
          {(item.price * (item.quantity || 1)).toLocaleString(undefined, {
            minimumFractionDigits: 0,
          })}
        </p>
      </span>
      <span className=" flex gap-1 justify-between">
        <figure className="w-[20%] self-center rounded-xl">
          <img
            loading="lazy"
            className=" object-contain rounded-xl"
            src={item.images.small}
            alt={item.name}
          />
        </figure>
        <span className=" flex self-end mr-2 mb-2 gap-2 border-[1px] border-gray-300">
          <button
            className=" w-6 text-center font-extrabold border-r-[1px] border-gray-300 bg-gray-200"
            onClick={() => {
              counter !== 1 && setCounter(counter - 1);
            }}
          >
            <MinusIcon className=" text-black " />
          </button>
          <p className="font-semibold text-lg">{counter}</p>
          <button
            className=" w-6  text-center font-extrabold border-r-[1px] border-gray-300 bg-gray-200"
            onClick={() => {
              setCounter(counter + 1);
            }}
          >
            <PlusIcon className=" text-black " />
          </button>
        </span>
      </span>
    </div>
  );
};
